import React, { useEffect, useState } from "react";
import "./MobileDrawer.scss";
import SideBar from "./SideBar/SideBar";
import logoImage from "../../assets/logo.png";
import { Link } from "react-router-dom";
import { HiPhone } from "react-icons/hi2";

export default function MobileDrawer() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className={`mobile-drawer ${scrolled ? "scrolled" : ""}`}>
      <SideBar />
      <Link to={"/"} className="mobile-drawer__logo">
        <img src={logoImage} alt="Logo Image" className="image" />
      </Link>
      <Link to={"tel:0652890653"} className="mobile-drawer__contact">
        <HiPhone />
      </Link>
    </div>
  );
}
